import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../utils/axiosInstance';
import { toast } from 'react-toastify';

const initialState = {
  loading: false,
  aiContents: [],
  error: null,
  count:0
};

// Fetch all AI contents
export const fetchAIContents = createAsyncThunk('aiContent/fetchAIContents', async (queryString, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/content${queryString?queryString:""}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch AI contents');
  }
});

// Create new AI content
export const RegenerateAIContent = createAsyncThunk('aiContent/RegenerateAIContent', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post('/ai-content', payload);
    toast.success('AI Content created successfully');
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to create AI Content');
  }
});

// Delete AI content
export const deleteAIContent = createAsyncThunk('aiContent/deleteAIContent', async (id, thunkAPI) => {
  try {
    await axiosInstance.delete(`/content/${id}`);
    toast.success('AI Content deleted successfully');
    return id;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete AI Content');
  }
});
export const approveAIContent = createAsyncThunk('aiContent/approveAIContent', async (data, thunkAPI) => {
  try {
    await axiosInstance.post(`/content/${data.uuid}/approve`, { source: data.integration });
    toast.success('AI Content Action successfully Completed');
    return data.uuid;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete AI Content');
  }
});
export const rejectAIContent = createAsyncThunk('aiContent/rejectAIContent', async (id, thunkAPI) => {
  try {
    await axiosInstance.post(`/content/${id}/reject`);
    toast.success('AI Content rejected successfully');
    return id;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete AI Content');
  }
});
export const editAIContent = createAsyncThunk('aiContent/editAIContent', async (data, thunkAPI) => {
  try {
    await axiosInstance.patch(`/content/${data.id}`, data.values);
    return data.id;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete AI Content');
  }
});
export const reuploadContent = createAsyncThunk('aiContent/reuploadContent', async (data, thunkAPI) => {
  try {
    await axiosInstance.post(`/content/${data.uuid}/upload`);
    return data.uuid;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete AI Content');
  }
});

const aiContentSlice = createSlice({
  name: 'aiContent',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchAIContents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAIContents.fulfilled, (state, action) => {
        state.loading = false;
        state.aiContents = action.payload?.data?.results || [];
        state.count = action.payload?.data?.count;
      })
      .addCase(fetchAIContents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create
      .addCase(RegenerateAIContent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(RegenerateAIContent.fulfilled, (state, action) => {
        state.loading = false;
        state.aiContents = [action.payload?.data, ...state.aiContents];
      })
      .addCase(RegenerateAIContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete
      .addCase(deleteAIContent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAIContent.fulfilled, (state, action) => {
        state.loading = false;
        state.aiContents = state.aiContents.filter((item) => item.id !== action.payload);
      })
      .addCase(deleteAIContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(rejectAIContent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(rejectAIContent.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(rejectAIContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(approveAIContent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveAIContent.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(approveAIContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(reuploadContent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(reuploadContent.fulfilled, (state, action) => {
        state.loading = false;
        if (action?.payload?.status == 200) {
          toast.success("Content Uploaded successfully")
        }
        state.error = null;
      })
      .addCase(reuploadContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default aiContentSlice.reducer;


